var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import TextField from '../TextField';
import { CalendarIcon } from '../Icon';
import IconButton from '../IconButton';
var DatePickerTextField = function (_a) {
    var InputProps = _a.InputProps, onIconClick = _a.onIconClick, props = __rest(_a, ["InputProps", "onIconClick"]);
    return (React.createElement(TextField, __assign({}, props, { type: "text", InputProps: __assign(__assign({}, InputProps), { endAdornment: (React.createElement(IconButton, { "aria-label": "calendar-icon-btn", onClick: onIconClick },
                React.createElement(CalendarIcon, { fontSize: "small" }))) }) })));
};
export default DatePickerTextField;
